import { render, staticRenderFns } from "./CreatePostModalWrapper.vue?vue&type=template&id=14e86e76"
import script from "./CreatePostModalWrapper.vue?vue&type=script&lang=js"
export * from "./CreatePostModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports